import { sreActions } from '@rosetta/react-sre';
import { userSelectors } from '@rosetta/gaia-data';
import { registerDevFunction } from 'modules/dev/consoleCommands';

registerDevFunction('enableAudioLog', (context) => () => {
  const { store } = context;
  const userId = userSelectors.getUserId(store.getState());
  store.dispatch(sreActions.enableAudioLog(userId, 'Gaia'));
});
